export default __webpack_public_path__ + "static/media/red-logo-covid-status.5aa4590b.svg";